import { Component, EventEmitter, OnInit, Input, Output, OnChanges, SimpleChanges, Inject, Optional, ViewChild } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ProjectMenu, ProjectService } from '@app/services/project.service';
import { DocumentsGridComponent } from '@app/shared/documents-grid/documents-grid.component';

@GridModalComponent('projectmenu')
@Component({
    selector: 'tt-project-menu',
    templateUrl: './project-menu.component.html',
    styleUrls: ['./project-menu.component.css'],
    standalone: false
})
export class ProjectMenuComponent implements OnInit, OnChanges {
    @Input()
    public params?: { project_keyno: string | number };

    public get?: ProjectMenu;

    @Output()
    public getLoaded = new EventEmitter<ProjectMenu>();

    public activityGrid?: GridOptions;

    public emailGrid?: GridOptions;

    // public documentsGrid?: GridOptions;

    @ViewChild(DocumentsGridComponent)
    public documentsGrid?: DocumentsGridComponent;

    public ordersGrid?: GridOptions;

    public purchasesGrid?: GridOptions;

    public incomingInvoicesGrid?: GridOptions;

    public powtimesGrid?: GridOptions;

    public dockpacksGrid?: GridOptions;

    constructor(
        private state: StateService,
        private project: ProjectService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) public navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public onTabChange() {
        if (this.get?.gb_projectmenu_main === 'CUSTACTS') {
            this.readActivityGrid();
        } else if (this.get?.gb_projectmenu_main === 'EMAILS') {
            this.readEmailGrid();
        } else if (this.get?.gb_projectmenu_main === 'DOCUMENTS') {
            this.readDocumentsGrid();
        } else if (this.get?.gb_projectmenu_main === 'ORDERHEADS') {
            this.readOrdersGrid();
        } else if (this.get?.gb_projectmenu_main === 'PURCHHEADS') {
            this.readPurchasesGrid();
        } else if (this.get?.gb_projectmenu_main === 'INCOMING_INVOICE') {
            this.readIncomingInvoicesGrid();
        } else if (this.get?.gb_projectmenu_main === 'POWTIMES') {
            this.readPowtimesGrid();
        } else if (this.get?.gb_projectmenu_main === 'DOCPACKS') {
            this.readDocPacksGrid();
        }
    }

    public async loadGet() {
        if (!!this.params) {
            this.get = await this.project.getProjectMenu(this.params);
            this.getLoaded.emit(this.get);
            this.navigator?.setHeading?.(this.get.webpage_heading ?? '');
        }
    }

    private async init() {
        await this.loadGet();
        this.onTabChange();
        // this.state.setTitleOverride(this.get?.project_name ?? '', false);
    }

    public async onProjectSubmit(event: { event: 'delete' | 'save' }) {
        if (event.event === 'delete') {
            this.navigator?.back();
        } else {
            await this.loadGet();
        }
    }

    private readActivityGrid() {
        if (!this.activityGrid) {
            this.activityGrid = new Grid().setRememberId('w_projectmenu.custacts_grid').setLoadDataFunction({
                method: 2452,
                parameters: () => ({
                    searchtext: '',
                    ok: '0',
                    filterfield: 'project_keyno',
                    filtervalue: this.get?.project_keyno,
                    custacttype: 'A',
                    acttype: 'all',
                    activitytype_no: '0',
                    actstatus_keyno: '0',
                    bg_main: 'SEARCH',
                    bg_search: 'RESULT',
                    member_portal_user_keyno: '0',
                    reg_of_portal_user_keyno: '0',
                    cust_no: '0',
                }),
            });
        } else {
            // this.activityGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readEmailGrid() {
        if (!this.emailGrid) {
            this.emailGrid = new Grid()
                .setRememberId('w_projectmenu_email_grid')
                .setLoadDataFunction({
                    method: 2971,
                    parameters: () => ({
                        argtype: 'project_keyno',
                        argvalue: this.get?.project_keyno,
                        searchtext: '',
                        doctype: 'd',
                        onlyFilenames: '0',
                    }),
                })
                .setCustomToolbarButtons([{ name: 'projectmenu_email_new', text: 'projectmenu_email_new', translate: true, icon: 'far fa-plus', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l', func: () => this.state.go('emailcreate', { webpage: 'projectmenu', argtype: 'project_keyno', argvalue: this.get?.project_keyno }) }]);
        } else {
            // this.emailGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readDocumentsGrid() {
        if (!this.documentsGrid) {
            // this.documentsGrid = new Grid().setRememberId('w_projectmenu.documents_grid').setLoadDataFunction({
            //     method: 2972,
            //     parameters: () => ({
            //         argtype: 'project_keyno',
            //         argvalue: this.get?.project_keyno,
            //         searchtext: '',
            //         doctype: 'd',
            //         onlyFilenames: '0',
            //     }),
            // });
        } else {
            this.documentsGrid.grid?.gridfunc?.read();
            // this.documentsGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readOrdersGrid() {
        if (!this.ordersGrid) {
            this.ordersGrid = new Grid().setRememberId('w_projectmenu.orderheads_grid').setLoadDataFunction({
                method: 2852,
                parameters: () => ({
                    cust_no: '0',
                    searchtext_customer: '',
                    orderstatus_id: '0',
                    filterval: '',
                    cust_name: '',
                    gb_ordertype: '0',
                    gb_orderdate: '0',
                    gb_orderstatus: '0',
                    ordertype_id: 'All',
                    cust_no_and_name: '0',
                    businessco_no: '99999',
                    show_setting: '1',
                    argtype: 'project_keyno',
                    argvalue: this.get?.project_keyno, //'11500',
                    show_all_orders: '1',
                    ordersearch: '',
                    show_new_order_button: '1',
                    page_heading: this.get?.webpage_heading, //'00 Testprosjekt x',
                    gb_regby: 'ALL',
                    show_gb_regby: '1',
                    reg_by_portal_user_keyno: '0',
                    date_fom: '1901-01-01',
                    date_tom: '2999-12-31',
                    dateselector_index: '8',
                    show_selection_ordertype: '1',
                    show_dateselector: '1',
                    date_fomtom: '1901-01-012999-12-31',
                    selected_order_internal_no: '0',
                    search_confirmed_deliverydate: '1',
                    current_portal_user_keyno: '1',
                    page: 1,
                    pageSize: 10,
                    gb_orderheads_related: 'orderheads_custact_related',
                    webpage: this.state.getCurrentPath(),
                }),
            });
        } else {
            // this.ordersGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readPurchasesGrid() {
        if (!this.purchasesGrid) {
            this.purchasesGrid = new Grid().setRememberId('w_projectmenu.purchheads_grid').setLoadDataFunction({
                method: 3059,
                parameters: () => ({
                    argtype: 'project_keyno',
                    argvalue: this.get?.project_keyno,
                    supplier_no: '0',
                    searchtext_supplier: '',
                    purchasestatus_id: '999',
                    filterval: '',
                    supplier_name: '',
                    supplier_no_and_name: '',
                    portal_user_keyno: '0',
                    gb_whos: '0',
                    gb_purchasetype: '0',
                    gb_purchasetype_purch: '0',
                    gb_purchdate: '',
                    webpage: this.state.getCurrentPath(),
                    businessco_no: '0',
                    searchtext: '',
                }),
            });
        } else {
            // this.purchasesGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readIncomingInvoicesGrid() {
        if (!this.incomingInvoicesGrid) {
            this.incomingInvoicesGrid = new Grid().setRememberId('linked_custactac').setLoadDataFunction({
                method: 3661,
                parameters: () => ({ project_keyno: this.get?.project_keyno }),
            });
        } else {
            // this.incomingInvoicesGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readPowtimesGrid() {
        if (!this.powtimesGrid) {
            this.powtimesGrid = new Grid().setRememberId('w_projectmenu.powtimes_grid').setLoadDataFunction({
                method: 2127,
                parameters: () => ({
                    businessco_no: '99999',
                    show_setting: '1',
                    argtype: '-',
                    argvalue: '-',
                    date_fom: '1901-01-01',
                    date_tom: '2999-12-31',
                    dateselector_index: '8',
                    view_id: 'w_powtimes.grid',
                    date_fomtom: '1901-01-012999-12-31',
                    labour_no: '0',
                    cust_no: '0',
                    cust_name: '',
                    project_keyno: this.get?.project_keyno,
                    project_name: this.get?.project_name,
                }),
            });
        } else {
            // this.powtimesGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private readDocPacksGrid() {
        if (!this.dockpacksGrid) {
            this.dockpacksGrid = new Grid()
                .setRememberId('projectmenu.docpack_grid')
                .setLoadDataFunction({
                    method: 3282,
                    parameters: () => ({
                        argtype: 'project_keyno',
                        argvalue: this.get?.project_keyno,
                    }),
                })
                .setCustomToolbarButtons([{ name: 'projectmenu_docpacktype_create', text: 'projectmenu_docpacktype_create', translate: true, icon: 'far fa-plus', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l', spinOnAction: true, func: this.addDocPack.bind(this) }]);
        } else {
            // this.dockpacksGrid.gridfunc?.read(); // commented out so it only reads on initial rendering, user will need to refresh page or move back to page to refresh.
        }
    }

    private async addDocPack() {
        if (!this.get) return;

        if (this.get.nbr_of_docpacktypes > '1') {
            this.state.go('docpackcreate', { argtype: 'project_keyno', argvalue: this.get.project_keyno });
        } else {
            const { errorcode, errormessage } = await this.project.createDocPack({ docpacktype_keyno: this.get.docpacktype_keyno, argtype: 'project_keyno', argvalue: this.get.project_keyno });

            if (errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.dockpacksGrid?.gridfunc?.read();
            }
        }
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '98vw', height: '95vh' });
            this.params = this.navigator.params as { project_keyno: string | number };
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!this.navigator) return;

        if (!!changes['params'] && changes['params']?.currentValue?.project_keyno !== changes['params']?.previousValue?.project_keyno) {
            this.init();
        }
    }
}
